import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=5df20171&"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports